import { useMutation } from "@tanstack/react-query";
import {
  setAllMessageNotificationAsRead,
  setMessageNotificationAsRead,
} from "../service/notification.service";
import { notificationMessagesCache } from "../service/NotificationMessagesCache";

export const useSetNotificationAsUnread = (
  storeId: string | undefined,
  uid: string | undefined
) => {
  return useMutation({
    mutationFn: (notificationId: string) =>
      setMessageNotificationAsRead(notificationId),
    onSuccess: (notification) => {
      if (storeId && uid && notification) {
        notificationMessagesCache.update(storeId, uid, [notification]);
      }
    },
  });
};

export const useSetAllNotificationsAsUnread = (
  storeId: string | undefined,
  uid: string | undefined
) => {
  return useMutation({
    mutationFn: (notificationIds: string[]) =>
      setAllMessageNotificationAsRead(notificationIds),
    onSuccess: (batchUpdateResponse) => {
      if (storeId && uid && batchUpdateResponse) {
        notificationMessagesCache.update(
          storeId,
          uid,
          batchUpdateResponse.updated
        );
      }
    },
  });
};
